import React, { useState, useEffect } from 'react';
import MetaDataTop                    from '../../../components/postBlog/metaDataTop';
import Wysiwyg                        from '../../../components/postBlog/wysiwyg';
import MetaDataDown                   from '../../../components/postBlog/metaDataDown';
import Button                         from '@mui/material/Button';
import Grid                           from '@mui/material/Grid';
import draftToHtml                    from "draftjs-to-html";
//import { convertFromHTML }            from "draft-convert";
import { EditorState, ContentState, 
	convertToRaw }                    from "draft-js";
import htmlToDraft                    from 'html-to-draftjs';
import { articleSearch, articleEdit } from '../../../apis/article';

const initialState = {
	_id        : "",
	url        : "",
	urlRegex   : false,
	status     : "draft",
	title      : "",
	desc       : "",
	shortDesc  : "",
	editorState: null,
	seoTitle   : "",
	seoDesc    : "",
	tags       : [],
	imgAlt     : "",
	img        : null,
	imgName    : "",
	flag       : false, //also contains the check if idEditable "published"
	loader     : true,
};

//editorState: EditorState.createWithContent (convertFromHTML (resp.text)),
export default function BlogFieldsModifier () {
	const [{ _id, url, urlRegex, status, title, desc, shortDesc, editorState,
		seoTitle, seoDesc, tags, imgAlt, img, imgName, flag, loader },
		setState]    = useState (initialState);
	const params     = new URLSearchParams (window.location.search);
	const redoBlogId = params.get ('title');


	useEffect(() => {
		const getData = async () => {
			try {
				const resp         = await articleSearch ({ 'url' : redoBlogId });
				const contentBlock = htmlToDraft(resp.text);
				const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
				const editorHtml   = EditorState.createWithContent(contentState);
				setState ({
					_id        : resp._id,
					url        : resp.url,
					urlRegex   : urlValid (resp.url),
					status     : resp.status,
					title      : resp.title,
					desc       : resp.desc,
					shortDesc  : resp.short_desc,
					editorState: editorHtml,
					seoTitle   : resp.seo_title,
					seoDesc    : resp.seo_desc,
					tags       : resp.tags,
					imgAlt     : resp.img_alt,
					img        : resp.img,
					imgName    : resp.img ? 'bImage': '',
					loader     : false,
					flag       : resp.status,
				});
			} catch (err) {
				setState (prevState => ({ ...prevState, 'flag': null }));
				console.error (err);
			}
		}
		getData ();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onChange= (e) => {
		const {name, value} = e.target;

		if (name === 'url')
			if (urlValid (value))
				return setState (prevState => ({ ...prevState, [name]: value, 'urlRegex': true }));
		else return setState (prevState => ({ ...prevState, [name]: value, 'urlRegex': false }));

		setState (prevState => ({ ...prevState, [name]: value }));
	}

	const handleEditorState = (value) => {
		setState (prevState => ({ ...prevState, 'editorState': value }));
	}

	const urlValid = (s) => {
		return (/[\w_-]+$/.test (s));
	}

	const handleHashTags = (arr) => {
		setState (prevState => ({ ...prevState, 'tags': arr }));
	}

	const handleImage = (e) => {
		const file   = e.target.files[0];
		const reader = new FileReader();
		reader.onloadend = () => {
			setState (prevState => ({ ...prevState, "imgName": file.name, "img": reader.result }));
			console.log ("img done");
		};
		reader.readAsDataURL (file);
	}

	const onSubmit = async () => {
		try {
			if (!urlRegex)
				return window.alert ("URL not acceptable!");

			if (!editorState)
				return window.alert ('Please write the content, in the editor, to post!');

			let edContent = draftToHtml (convertToRaw(editorState.getCurrentContent ()));

			if (edContent.trim () === "<p></p>")
				return window.alert ('Please write the content, in the editor, to post!');

			var data = {
				"_id"       : _id,
				"url"       :url,
				"status"    :status,
				"title"     :title,
				"desc"      :desc,
				"short_desc":shortDesc,
				"text"      :draftToHtml (convertToRaw (editorState.getCurrentContent ())),
				"seo_title" :seoTitle,
				"seo_desc"  :seoDesc,
				"tags"      :tags,
				"img_alt"   :imgAlt,
				"img"       :img,
			};

			let resp    = await articleEdit (data);
			let respTxt = `Post www.overseas.one/blog/${resp.url} published!`;
			window.alert (respTxt);
			window.close ();//works if opened by self and close by self

		}
		catch (err) {
			console.error (err);
			window.alert ("Please fill in the required fields.");
		}
	}

	if (flag === null)
		return (
			<p>NO DATA FOUND.<br /> SUGGESTED ARTICLES </p>
		);

	if (flag === 'published')
		return (
			<p style={{margin: "50px 0 0 50px"}}><b>Aldready Published. Permissions Not Found.</b></p>
		);

	if (loader === true)
		return (
			<p style={{margin: "50px 0 0 50px"}}><b>Loading...</b></p>
		);

	return (
		<>
			<MetaDataTop
				url={url}
				urlRegex={urlRegex}
				status={status}
				title={title}
				desc={desc}
				shortDesc={shortDesc}
				onChange={onChange}
			/>
			<Wysiwyg
				editorState={editorState}
				handleEditorState={handleEditorState}
			/>
			<MetaDataDown
				seoTitle={seoTitle}
				seoDesc={seoDesc}
				imgAlt={imgAlt}
				img={img}
				imgName={imgName}
				onChange={onChange}
				handleImage={handleImage}
				tags={tags}
				handleHashTags={handleHashTags}
			/>
			<Grid container spacing={1}>
				<Grid item xs={false} md={10} style={{backgroundColor: ''}}>
				</Grid>
				<Grid item xs={12} md={1} style={{margin: '20px 10px 20px 20px', display: 'flex', justifyContent: 'right'}}>
					<Button variant="contained" onClick={onSubmit}>Post</Button>
				</Grid>
			</Grid>
		</>
	);
}
